/*
 * firebase.js
 */

 import firebase from 'firebase';
 import axios from 'axios';
 import idb from 'idb';
  // Initialize Firebase
const config = {
    apiKey: "AIzaSyCGg2SorVfqif2EQoIO1ooQYLqSqTmLVhI",
    authDomain: "dailyquotes-51929.firebaseapp.com",
    databaseURL: "https://dailyquotes-51929.firebaseio.com",
    projectId: "dailyquotes-51929",
    storageBucket: "dailyquotes-51929.appspot.com",
    messagingSenderId: "341512299670"
  };
// Topic to which to subscribe
const topic = "daily_quotes";
//const topic = "tumblrquotes";

const sKey= "AAAAT4O4JJY:APA91bHq1Z2unEvWdwCdUEMQ1C2Zq0NTe_8UcyvUcTxNgr5X9LHhOznhl2BbtF3jGQ-K2aFGX9UtVfMr90_AS3uy1cEq-rlcPXtJCfKXKSV-9_qKtpyxe7sv5RjMtry7WdA7ytvOmJtD";
firebase.initializeApp(config);

const firebase_messaging = firebase.messaging();

// db
export const DB_NAME = "daily_quote_db";
export const STORE_NAME = "latest_quote";
// DB Resource
export const db = idb.open(DB_NAME, 2, upgradeDB => {
    upgradeDB.createObjectStore(STORE_NAME,{keyPath: "cid", autoIncrement: true});
});



// Vapid Key (used to enable push messaging in browser)
firebase_messaging.usePublicVapidKey("BHjqhPeGFl-NVOZuZwTmcil-8pxjd6anqdE_I_rSLgQaJ2IVaswfhMpgPybsyTPsXmb8T-fFxuGieMfrEtoLtg0");


firebase_messaging.requestPermission()
.then(function(){
     return firebase_messaging.getToken()
})
.then(function(token){
    let topicSubscriptionURI = `https://iid.googleapis.com/iid/v1/${token}/rel/topics/${topic}`;
    return axios({
        method: 'post',
        url: topicSubscriptionURI,
        headers: {
            'Authorization': `key=${sKey}`,
            'Content-Type':'application/json'
        }
    })

})
.then(function(res){
})
.catch(function(err){
    console.log(err)
})

    
    //OnMessage
firebase_messaging.onMessage((payload)=>{
    let quote = payload.data,
        received = new Date();
    // add timestamp
    quote.received = received
    db.then(dbResource => {

        const tx = dbResource.transaction(STORE_NAME,'readwrite');
        tx.objectStore(STORE_NAME).put(quote);
    });
})


export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js